/**
 * Eric 2026-05-12 — Modale Rapport Markdown (Q&R / Scripts / Procédures).
 * Extraite de VideoDetailPage.js dans le cadre du refacto P2.
 * Affiche le markdown du rapport + boutons d'export .md / PDF.
 */
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function ReportMarkdownModal({
  report,
  onClose,
  onDownloadMarkdown,
  onDownloadPdf,
  onDownloadWord,
  lang = "fr",
}) {
  if (!report) return null;
  // Tâche 1266 (Eric 2026-06-28, non corrigé au premier passage) — Le rapport
  // des PROCÉDURES sort uniquement en Word, comme les Q&R et les concepts : un
  // .md ou un PDF imprimé se retouche mal et repart en circulation.
  const wordOnly = report.type === "procedures";
  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="report-modal"
    >
      <div
        className="bg-white border border-zinc-200 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-zinc-200">
          <div>
            <h3 className="text-lg font-semibold flex items-center gap-2 text-zinc-900">
              📄 {report.title}
            </h3>
            <p className="text-xs text-zinc-500 mt-1">
              {wordOnly
                ? (lang === "fr"
                    ? "Ce rapport s'exporte en Word (.docx) uniquement."
                    : "This report exports to Word (.docx) only.")
                : (lang === "fr"
                    ? "Vous pouvez exporter ce rapport en PDF ou Markdown."
                    : "Export this report as PDF or Markdown.")}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-zinc-100 rounded-lg transition-colors"
            data-testid="report-modal-close"
            aria-label="Fermer"
          >
            ✕
          </button>
        </div>
        <div
          className="flex-1 overflow-y-auto p-6 prose prose-sm max-w-none prose-headings:text-zinc-900 prose-table:text-xs prose-th:bg-zinc-100 prose-th:px-2 prose-th:py-1 prose-td:px-2 prose-td:py-1 prose-td:border prose-th:border prose-table:border prose-table:border-collapse"
          data-testid="report-modal-content"
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{report.markdown}</ReactMarkdown>
        </div>
        <div className="flex items-center justify-end gap-2 p-4 border-t border-zinc-200 bg-zinc-50 rounded-b-2xl">
          {wordOnly ? (
            <button
              onClick={() => onDownloadWord?.(report)}
              className="px-3 py-2 rounded-lg bg-[#002FA7] hover:bg-[#001F7A] text-white text-xs font-medium"
              data-testid="report-modal-download-word"
              title={lang === "fr"
                ? "Télécharger le rapport complet en Word (.docx)"
                : "Download the full report as Word (.docx)"}
            >
              📝 {lang === "fr" ? "Télécharger en Word" : "Download as Word"}
            </button>
          ) : (
            <>
              <button
                onClick={() => onDownloadMarkdown(report)}
                className="px-3 py-2 rounded-lg border border-zinc-300 bg-white hover:bg-zinc-100 text-xs font-medium text-zinc-700"
                data-testid="report-modal-download-md"
              >
                💾 {lang === "fr" ? "Télécharger .md" : "Download .md"}
              </button>
              <button
                onClick={() => {
                  const tempDiv = document.querySelector('[data-testid="report-modal-content"]');
                  const htmlContent = tempDiv ? tempDiv.innerHTML : "";
                  onDownloadPdf({ ...report, htmlContent });
                }}
                className="px-3 py-2 rounded-lg bg-[#002FA7] hover:bg-[#001F7A] text-white text-xs font-medium"
                data-testid="report-modal-download-pdf"
              >
                🖨️ {lang === "fr" ? "Imprimer / PDF" : "Print / PDF"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
